import { render, staticRenderFns } from "./NovoEmprestimo.vue?vue&type=template&id=dfa93006&scoped=true&"
import script from "./NovoEmprestimo.vue?vue&type=script&lang=js&"
export * from "./NovoEmprestimo.vue?vue&type=script&lang=js&"
import style0 from "./NovoEmprestimo.vue?vue&type=style&index=0&id=dfa93006&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa93006",
  null
  
)

export default component.exports